import * as qs from 'qs';
import { axios } from '~/libs/axios';
import {
  type TCoinSnippetConfigResponse,
  type TCoinSnippetTimeResponse,
  type TCoinSnippetSearchRequest,
  type TCoinSnippetSearchResponse,
  type TCoinSnippetAssetsResponse,
  type TCoinSnippetAssetsValidateResponse,
  type TCoinSnippetHistoryRequest,
  type TCoinSnippetHistoryResponse,
  type TCoinSnippetWalletsRequest,
  type TCoinSnippetWalletsResponse,
  type Chain,
} from '~/types';
import { ExclusiveRunner } from '~/libs/async';

const runner = ExclusiveRunner.create();

const getConfig = async (): Promise<TCoinSnippetConfigResponse> => {
  const { data } = await axios.get<TCoinSnippetConfigResponse>(
    '/coin_snippet/config',
  );
  return data;
};

const getTime = async (): Promise<TCoinSnippetTimeResponse> => {
  const { data } =
    await axios.get<TCoinSnippetTimeResponse>('/coin_snippet/time');
  return data;
};

const search = async (
  params: TCoinSnippetSearchRequest,
): Promise<TCoinSnippetSearchResponse> => {
  const queryParams = qs.stringify(params);
  const { data } = await axios.get<TCoinSnippetSearchResponse>(
    '/coin_snippet/search?' + queryParams,
  );
  return data;
};

const getAsset = async (
  asset_address: string,
  chain: Chain,
): Promise<TCoinSnippetAssetsResponse> => {
  const queryParams = qs.stringify({ asset_address, chain });

  const { data } = await runner.run({
    key: ['coinSnippet', 'getAsset', queryParams],
    fn: () =>
      axios.get<TCoinSnippetAssetsResponse>(
        '/coin_snippet/assets?' + queryParams,
      ),
  });

  return data;
};

export const validateAsset = async (
  asset_address: string,
  chain: Chain,
): Promise<TCoinSnippetAssetsValidateResponse> => {
  const queryParams = qs.stringify({ asset_address, chain });

  const { data } = await runner.run({
    key: ['coinSnippet', 'validateAssets', queryParams],
    fn: async () =>
      await axios.get<TCoinSnippetAssetsValidateResponse>(
        '/coin_snippet/assets/validate?' + queryParams,
      ),
  });

  return data;
};

const getHistory = async (
  params: TCoinSnippetHistoryRequest,
): Promise<TCoinSnippetHistoryResponse> => {
  const queryParams = qs.stringify(params);
  const { data } = await axios.get<TCoinSnippetHistoryResponse>(
    '/coin_snippet/history?' + queryParams,
  );
  return data;
};

const getWallets = async (
  params: TCoinSnippetWalletsRequest,
): Promise<TCoinSnippetWalletsResponse> => {
  const queryParams = qs.stringify(params);
  const { data } = await axios.get<TCoinSnippetWalletsResponse>(
    '/coin_snippet/wallets?' + queryParams,
  );
  return data;
};

export const coinSnippetAPI = {
  getConfig,
  getTime,
  search,
  getAsset,
  validateAsset,
  getHistory,
  getWallets,
};
